import { useFormState } from "react-final-form";
import Alert from "../../components/alert";
import { jsx as _jsx } from "react/jsx-runtime";
function SubmitError(props) {
  const {
    submitError
  } = useFormState({
    subscription: {
      submitError: true
    }
  });
  if (submitError) {
    return /*#__PURE__*/_jsx(Alert, {
      ...props,
      message: submitError,
      type: "error"
    });
  }
  return null;
}
export default SubmitError;